__turbopack_context__.v({
  "className": "roboto_71e0a4b0-module__32muLa__className",
});
